import { Article } from '~/contracts/flp';

/**
 * Constructs a query string for performing an '$in' Filtering operation through the Strapi CMS API.
 *
 * [See for more info.](https://docs.strapi.io/dev-docs/api/rest/filters-locale-publication#filtering)
 * @param field - The Article field used for filtering.
 * @param collection - Collection of values used to determine whether a given instance of the field exists.
 */
export function getQueryParameterFilters(
  field: keyof Article,
  collection: string[]
) {
  return collection
    .map(c => `filters[${field}][$eq]=${encodeURIComponent(c)}`)
    .join('&');
}
